import React from 'react';

import SectionText from '../../presentational/SectionText';
import DotPoints from '../../presentational/DotPoints';
import data from '../../../core/data';

import cx from 'classnames';
import { Track, TrackedDiv, TrackDocument } from 'react-track';
import { topTop,
        topBottom,
        centerCenter,
        topCenter,
        bottomBottom,
        bottomTop,
        getDocumentRect,
        getDocumentElement,
        calculateScrollY } from 'react-track/tracking-formulas';
import {tween, combine} from 'react-imation';
import {rgb, rgba, scale, rotate,
        px, percent, translate3d} from 'react-imation/tween-value-factories';

const WhoIsItFor = (props) => {
  const treatmentPoints = data.phyto.uses.treatmentPoints;
  const usesPoints = data.phyto.uses.usesPoints;
  const body = data.phyto.uses.body;

  return (
    <section id="who-for">
      <div className="circle-powder-backdrop hidden-md hidden-sm hidden-xs" />
      <div className="powder-backdrop" />
      <TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
                               topTop, topBottom, topCenter, centerCenter]}>
      {(documentElement, documentRect, scrollY, topTop,
        topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
        <div className="container">
          <Track component="div" className="dotpoints" formulas={[topBottom, topCenter]}>
            {(DIV, posTopBottom, posTopCenter) =>
              <DIV>
                <h1>The treatment:</h1>
                <DotPoints className={cx('herbs',{'animated': scrollY > (posTopCenter-150)})} array={ treatmentPoints } />
              </DIV>
          }</Track>
          <Track component="div" className="dotpoints" formulas={[topBottom, topCenter]}>
            {(DIV, posTopBottom, posTopCenter) =>
              <DIV>
                <h1>It is great as:</h1>
                <DotPoints className={cx('herbs',{'animated': scrollY > (posTopCenter-150)})} array={ usesPoints } />
              </DIV>
          }</Track>
          <p className="body"><b>Recommended course of treatment:</b>{ body }</p>
        </div>
      }</TrackDocument>
    </section>
  )
}

export default WhoIsItFor;



/** WEBPACK FOOTER **
 ** ./src/components/containers/bpeel/WhoIsItFor.jsx
 **/